import React from 'react'
import { Carousel } from 'react-responsive-carousel'
//bs ye khlchi line tkl kki slider chi css yete
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import data from "../assets/data.json"
// te n img online nhi so mi path pata krun json mde taknar
// import name from '../assets/yt.png';

const Work = () => {
  return (
    <div id='work'>
        <h2>WORK</h2>
        <section>
            <article>
                <Carousel
                    showArrows={false}
                    showStatus={false}
                    showIndicators={false}
                    showThumbs={false}
                    infiniteLoop={true}
                    autoPlay={true}
                    interval={1700}
                >
                    {
                        data.projects.map(i=>(
                            <div key={i.title} className='workItem'>
                                <img src={i.imgSrc} alt={i.title} />
                                <aside>
                                    <h3>{i.title}</h3>
                                    <p>{i.description}</p>
                                    <a href={i.url} target='blank'>View Demo</a>
                                </aside>
                            </div>
                        ))
                    }
                </Carousel>
            </article>
        </section>
    </div>
  )
}

export default Work